var _rect, _rect2, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductPlaceholderCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 24,
    fill: "#FCFAF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 66,
    width: 216,
    height: 152,
    rx: 18,
    fill: "#FFFEFC",
    stroke: "#EAE3D8",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 118,
    r: 12,
    fill: "#E7DED1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138 182L181.507 145.744C185.235 142.636 190.635 142.731 194.253 145.968L213.557 163.24C217.179 166.481 222.587 166.571 226.314 163.451L249.543 144.012C253.278 140.887 258.697 140.984 262.317 144.241L292 170.947V190H138V182Z",
    fill: "#DDD4C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlaceholderCard);
export default __webpack_public_path__ + "static/media/product-placeholder-card.0c2c153b7c9a9a71310ab0142bc4ac53.svg";
export { ForwardRef as ReactComponent };